import React from "react";
import './css/dash.css';
import logo from './css/img/newLogo.svg';
import dataLinks from '../dataLinks';

export default function Dash() {
    return (
        <div className="dash">
            <div className="dash__grid">
                <article className="dash__card dash__card--logo">
                    <img src={logo} alt="SoloPixelDev logo" className="dash__logo" />
                    <p className="dash__wordmark">
                        Solopixel<span className="dash__accent">dev</span>
                    </p>
                </article>

                <article className="dash__card dash__card--intro">
                    <p>
                        Hi, I'm Maz a Freelance Web Developer based in London/UK.
                        Through using the latest web technologies I create functional,
                        engaging and visually appealing web applications that will meet your
                        business needs. Let's work together to build something amazing.
                    </p>
                </article>

                <article className="dash__card dash__card--services">
                    <h2 className="dash__services-title">Services</h2>
                    <ul className="dash__services-list">
                        <li>Web Design</li>
                        <li>Web Development</li>
                        <li>App Development</li>
                        <li>Website Maintenance</li>
                        <li>Consultations & Support</li>
                    </ul>
                </article>

                <article className="dash__card dash__card--soon">
                    <h1 className="dash__soon-title">NEW WEBSITE COMING SOON</h1>
                </article>

                <article className="dash__card dash__card--contact">
                    <a href={dataLinks.email} className="dash__contact-link">
                        contact@solopixeldev.co.uk
                    </a>
                </article>
            </div>
        </div>
    );
}
